export default function Index(){
    return(
        <div>
            contact
        </div>
    )
}